module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hallwil-ed286d64f159071c48e8b53b12bae0cb.svg";